import { render, staticRenderFns } from "./MatchParticipant.vue?vue&type=template&id=559b4216&scoped=true"
import script from "./MatchParticipant.vue?vue&type=script&lang=js"
export * from "./MatchParticipant.vue?vue&type=script&lang=js"
import style0 from "./MatchParticipant.vue?vue&type=style&index=0&id=559b4216&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559b4216",
  null
  
)

export default component.exports